import "../../styles/HomeBlogs.css";

export default function HomeBlogs() {
  return (
    <section className="blogs-section">
      <div className="blogs-container">

        {/* HEADER */}
        <div className="blogs-header">
          <span className="blogs-tag">Insights & Analysis</span>
          <h2 className="blogs-title">
            Legal Insights & <span>Updates</span>
          </h2>
          <p className="blogs-subtitle">
            Expert insights on legal trends, case studies, and practical guidance for businesses and individuals
          </p>
        </div>

        {/* BLOG CARDS */}
        <div className="blogs-grid">

          {/* CARD 1 - With Category Tag */}
          <div className="blog-card professional" id="card-border">
            <div className="card-badge">Civil Law</div>
            <div className="card-image-wrapper">
              <img
                src="/Home/le1.jpg"
                alt="Basics of Law"
                loading="lazy"
              />
              <div className="image-overlay"></div>
            </div>
            <div className="card-content">
              <div className="card-meta">
                <span className="card-date">January 12, 2025</span>
                <span className="read-time">• 6 min read</span>
              </div>
              <h3 className="card-title">Foundations of Legal Systems</h3>
              <p className="card-excerpt">
                Understanding how legal frameworks are constructed and their impact on societal structures.
                A comprehensive guide to navigating legal principles.
              </p>

            </div>
          </div>

          {/* CARD 2 - With Status */}
          <div className="blog-card professional" id="card-border">
            <div className="card-badge">Featured</div>
            <div className="card-image-wrapper">
              <img
                src="/Home/le2.jpg"
                alt="Understanding Legal Rights"
                loading="lazy"
              />
              <div className="image-overlay"></div>
            </div>
            <div className="card-content">
              <div className="card-meta">
                <span className="card-date">January 12, 2025</span>
                <span className="read-time">• 8 min read</span>
              </div>
              <h3 className="card-title">Comprehensive Guide to Individual Rights</h3>
              <p className="card-excerpt">
                Explore the fundamental rights protected under constitutional law and their practical
                applications in various legal scenarios.
              </p>

            </div>
          </div>

          {/* CARD 3 - With Popular Indicator */}
          <div className="blog-card professional" id="card-border">
            <div className="card-badge">Trending</div>
            <div className="card-image-wrapper">
              <img
                src="/Home/le3.jpg"
                alt="Types of Legal Cases"
                loading="lazy"
              />
              <div className="image-overlay"></div>
            </div>
            <div className="card-content">
              <div className="card-meta">
                <span className="card-date">January 12, 2025</span>
                <span className="read-time">• 10 min read</span>
              </div>
              <h3 className="card-title">Navigating Different Legal Proceedings</h3>
              <p className="card-excerpt">
                Detailed breakdown of civil, criminal, and corporate litigation processes with
                real-world case studies and strategic considerations.
              </p>

            </div>
          </div>

        </div>

      </div>
    </section>
  );
}